import { MIN_CARD_AMOUNT, REDUCER_ACTIONS } from "./constants";

const integerPositiveRegex = /^(?:\d+)?$/;

export const cardAmountReducer = (state, action) => {
  switch (action.type) {
    case REDUCER_ACTIONS.ADD_QUANTITY:
      return { ...state, value: Number(state.value + 1) };
    case REDUCER_ACTIONS.SUBTRACT_QUANTITY:
      if (state.value > MIN_CARD_AMOUNT) {
        return { ...state, value: Number(state.value - 1) };
      }
      return state;
    case REDUCER_ACTIONS.UPDATE_QUANTITY_ON_MOBILE_FIELD:
      if (integerPositiveRegex.test(action.payload)) {
        return { ...state, value: Number(action.payload) };
      }
      return state;
    default:
      throw new Error(`Action type "${action.type}" is not supported.`);
  }
};
